import type { NavMesh } from '@recast-navigation/core';
import { Group, Vector2 } from 'three';

export class Hole extends Group {
  /**
   * Indicates whether this object is a hole.
   */
  isHole: boolean = true;

  /**
   * Location coordinates for the pivot point of the course in Longitude/Latitude format (X/Y) format.
   */
  location: Vector2;

  /**
   * The nav mesh associated with this hole.
   */
  navMesh: NavMesh;

  constructor(location: Vector2, navMesh: NavMesh) {
    super();
    this.name = 'Hole';
    this.navMesh = navMesh;
    this.location = location;
  }

  // Override the copy method to ensure correct copying behavior
  copy(source: Hole, recursive?: boolean): this {
    super.copy(source, recursive);
    this.navMesh = source.navMesh;
    this.isHole = source.isHole;
    this.name = source.name;
    this.location = source.location.clone();
    return this;
  }
}
